import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import useSearch from 'hooks/useSearch';
import CarouselItem from './components/CarouselItem';
import CategoryItem from './components/CategoryItem';
import NoResult from '../NoResult';

import type { SizesPostListType } from './types';

type Props = {
  SizesList: SizesPostListType[];
};

const SizesPostList = ({ SizesList }: Props) => {
  const { query } = useSearch();
  const searchSizes = (searchQuery: string) => {
    const allSizes = SizesList.flatMap(item => item.sizes);
    return allSizes.filter(size => size.name.toLowerCase().includes(searchQuery.toLowerCase()));
  };

  const searchResults = query ? searchSizes(query) : null;

  let content;
  if (searchResults) {
    content = searchResults.length > 0 ? <CategoryItem SizesList={searchResults} /> : <NoResult />;
  } else if (SizesList.length === 1 && !SizesList[0].SizesSeeMoreLink) {
    content = <CategoryItem SizesList={SizesList} />;
  } else {
    content = <CarouselItem SizesList={SizesList} />;
  }

  return <HorizontalContainer>{content}</HorizontalContainer>;
};

export default SizesPostList;
